module.exports = __webpack_public_path__ + "media/images/flf-anilina_semianilina-222ea36e4a28174a50eabd366247e0cf.jpg";